import { Breadcrumbs, Link } from "@mui/material";
import React, { useContext } from 'react';
import { FormattedMessage } from "react-intl";
import { useSelector } from 'react-redux/es/exports';
import breadCrumbsList from '../../resources/json/fleetcrumbs.json';
import { styles } from '../../style/style';
import { HistoryContext } from './HistoryProvider';



export default function FleetBreadcrumbs(){

    const {urlHistory} = useContext(HistoryContext);
    let urlList = [...new Set(urlHistory.split(','))];
    let pathList = [];
    let orderNum = "testing";
    const orderDetailData = useSelector((state) => state.orderDetail.orderDetailData);
    if(orderDetailData !== undefined){
        orderNum = orderDetailData.payload.vehOrderNum;
    }


    if (urlList[urlList.length - 1] === "dashboard") {
        pathList = breadCrumbsList.dashboard.split(',');
    } else if (urlList[urlList.length - 1] === "ordersummary") {
        pathList = breadCrumbsList.ordersummary.split(',');  
    } else if (urlList[urlList.length - 1] === "advancedsearch") {
        pathList = breadCrumbsList.advancedsearch.split(',');
    } else if (urlList[urlList.length - 1] === "maintenancetable") {
        pathList = breadCrumbsList.maintenancetable.split(',');
    } else if (urlList[urlList.length - 1] === "newstable") {
        pathList = breadCrumbsList.newstable.split(',');
    } else if (urlList[urlList.length - 1] === "orderrequestlist") {
        if (urlList.includes('advancedsearch')){
            pathList = breadCrumbsList.orderrequestlistfromadvancedsearch.split(',');
        } else {
            pathList = breadCrumbsList.orderrequestlistfromhome.split(',');
        }
    } else if (urlList[urlList.length - 1] === "orderdetail") {
        if (urlList.includes('advancedsearch')){
            pathList = breadCrumbsList.orderdetailfromadvancedsearch.split(',');
        } else {
            pathList = breadCrumbsList.orderdetailfromhome.split(',');
        }
    }


    let crumbList = [];

    for (let i = 0; i < pathList.length; i++) {
        if(i === pathList.length - 1){
            if(pathList[i] === "orderdetail"){
                crumbList.push(<Link key={i} id={pathList[i]+"BreadCrumb"} sx = {styles.currentBreadCrumb} current = 'true' active = 'false' underline="none" color="text.primary"><FormattedMessage id={'breadcrumbs.' + pathList[i]}/>: {orderNum}</Link>)
            } else {
                crumbList.push(<Link key={i} id={pathList[i]+"BreadCrumb"} sx = {styles.currentBreadCrumb} current = 'true' active = 'false' underline="none" color="text.primary"><FormattedMessage id={'breadcrumbs.' + pathList[i]}/></Link>)
            }
        } else {
            crumbList.push(<Link key={i} id={pathList[i]+"BreadCrumb"} sx = {styles.previousBreadCrumb} active = 'true' href={pathList[i]} underline="hover" color="inherit"><FormattedMessage id={'breadcrumbs.' + pathList[i]}/></Link>)
        }
    }

    if(crumbList.length === 1){
        return(
            <Breadcrumbs separator="›"></Breadcrumbs>
        )
    } else {
        return(
                <Breadcrumbs separator="›">
                    {crumbList}
                </Breadcrumbs>
        );
    }
}